import { useState, useEffect } from "react";

import { FaCog, FaUser, FaDoorOpen, FaCar, FaChartPie } from "react-icons/fa";
import { MdQrCodeScanner } from "react-icons/md";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
import axios from "axios";

export default function Home() {
  const API_BASE = "https://srv968119.hstgr.cloud";
  const [statu, setStatu] = useState(localStorage.getItem("statu"));

  // Ajoute ce useEffect pour écouter les changements de localStorage
  useEffect(() => {
    const onStorage = () => setStatu(localStorage.getItem("statu"));
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // Mets à jour filteredMenu à chaque rendu
  const menuItems = [
    {
      name: "GESTION DES VEHICULES",
      icon: <FaCar />,
      color: "bg-gray-100",
      page: "/menuvehicule",
      roles: ["enregistreur", "admin", "admin_police", "admin_gendarmerie", "transport", "admin_douane", "controleur"]
    },
    {
      name: "POSTES DE CONTRÔLE",
      icon: <MdQrCodeScanner />,
      color: "bg-gray-100",
      page: "/menucheckpoint",
      roles: ["admin_police", "admin_gendarmerie", "admin", "transport", "admin_douane"]
    },
    {
      name: "STATISTIQUES ET RAPPORTS",
      icon: <FaChartPie />,
      color: "bg-gray-100",
      page: "/statistiques",
      roles: ["admin", "transport", "admin_douane"]
    },
    {
      name: "GESTION DES UTILISATEURS",
      icon: <FaUser />,color: "bg-gray-100",
      page: "/users",
      roles: ["admin", "admin_douane", "admin_police", "admin_gendarmerie"]
    },
    {
      name: "DÉCONNECTER",
      icon: <FaDoorOpen />,
      color: "bg-red-100",
      page: "/",
      roles: ["admin", "admin_police", "admin_gendarmerie", "enregistreur", "transport", "admin_douane"]
    },
  ];

  const filteredMenu = menuItems.filter((item) => item.roles.includes(statu));

  const monthNames = [
    "Jan",
    "Fév",
    "Mar",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Août",
    "Sep",
    "Oct",
    "Nov",
    "Déc",
  ];

  const [time, setTime] = useState(new Date());
  const [vehicleStats, setVehicleStats] = useState([]);
  const [checkStats, setCheckStats] = useState({
    total: 0,
    today: 0,
    last30Days: 0,
  });
  const [loading, setLoading] = useState(true);
  const [totalVehicules, setTotalVehicules] = useState(0);

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);

        // Récupérer les stats des véhicules
        const vehiclesRes = await axios.get(
          `${API_BASE}/statistique/vehicules/stats?year=2017`
        );
        const formattedData = vehiclesRes.data.map((item) => ({
          name: monthNames[item.month - 1],
          count: item.count,
        }));
        setVehicleStats(formattedData);

        // Récupérer les stats des checks
        const checksRes = await axios.get(
          `${API_BASE}/statistique/checks/stats`
        );
        setCheckStats(checksRes.data);
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [selectedYear]);

  useEffect(() => {
    const fetchTotalVehicules = async () => {
      try {
        // On récupère juste la première page, le total est dans la réponse
        const res = await axios.get(`${API_BASE}/vehicules?page=1&limit=1`);
        setTotalVehicules(res.data.totalVehicules);
      } catch (error) {
        console.error("Erreur récupération total véhicules :", error);
      }
    };
    fetchTotalVehicules();
  }, []);

  return (
    <div className="w-full max-w-screen-xl mx-auto flex flex-col items-center text-white px-3 sm:px-4 md:px-6 lg:px-8 md:pt-4 sm:pt-3 pt-21 pb-8">
      {/* Year Selector */}


      {/* Statistiques */}
      {statu === "admin" && (
        <div className="w-full grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          <div className="stat place-items-center bg-white/70 dark:bg-slate-800/60 backdrop-blur rounded-xl border border-slate-200/60 dark:border-slate-700">
            <div className="font-bold text-black dark:text-white">Étiquettes créées</div>
            <div className=" text-gray-700 sm:text-sm dark:text-white">
              {totalVehicules}
            </div>
            <div className="stat-desc text-gray-500">Total</div>
          </div>
          <div className="stat place-items-center bg-white/70 dark:bg-slate-800/60 backdrop-blur rounded-xl border border-slate-200/60 dark:border-slate-700">
            <div className=" font-bold text-black dark:text-white">Contrôles totaux</div>
            <div className=" text-gray-700 dark:text-white">{checkStats.total}</div>
            <div className="stat-desc text-gray-500">depuis le début</div>
          </div>
          <div className="stat place-items-center bg-white/70 dark:bg-slate-800/60 backdrop-blur rounded-xl border border-slate-200/60 dark:border-slate-700">
            <div className="font-bold text-black dark:text-white">Contrôles aujourd'hui</div>
            <div className=" text-gray-700 dark:text-white">{checkStats.today}</div>
          </div>
          <div className="stat place-items-center bg-white/70 dark:bg-slate-800/60 backdrop-blur rounded-xl border border-slate-200/60 dark:border-slate-700">
            <div className="font-bold text-black dark:text-white">30 derniers jours</div>
            <div className=" text-gray-700 dark:text-white">{checkStats.last30Days}</div>
          </div>
        </div>
      )}

      {/* Menu */}
      <div className="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4 mt-6">
        {filteredMenu.map((item, index) => {
          const card = (
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.35, delay: index * 0.06 }}
              className={`w-full h-28 hover:shadow-xl sm:h-32 md:h-36 px-4 py-4 sm:px-6 sm:py-6 flex flex-col items-center justify-center rounded-xl shadow-lg cursor-pointer text-black ${item.color}`}
            >
              <div className="text-2xl sm:text-3xl">{item.icon}</div>
              <span className="mt-2 text-center text-xs sm:text-sm md:text-base font-semibold">
                {item.name}
              </span>
            </motion.div>
          );

          return item.name === "DÉCONNECTER" || item.name === "Déconnexion" ? (
            <Link
              to={item.page}
              key={index}
              className="transition hover:scale-[1.02]"
              onClick={() => {
                const numeroSerie = localStorage.getItem("numero_serie");
                localStorage.clear();
                if (numeroSerie) localStorage.setItem("numero_serie", numeroSerie);
              }}
            >
              {card}
            </Link>
          ) : (
            <Link to={item.page} key={index} className="transition hover:scale-[1.02]">
              {card}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
